<template>
  <div class="warper">
    <div class="header">
      <a href="###">旧版</a>
      <a href="###">无障碍浏览</a>
    </div>
    <div class="logo">
      <img src="../assets/img/logo.png" alt="" />
    </div>
    <!-- 搜索 -->
    <div class="searchBar">
      <input
        type="text"
        name=""
        placeholder="请输入关键字查询"
        v-model="search"
        @input="changeKey"
        @keyup.enter="btn_seach"
         maxlength="50"
      />
      <input type="button" value="" @click="btn_seach" />
    </div>
    <!-- 热词 -->
    <div class="hot">
      <ul>
        <li v-for="(item, index) in hots" :key="index">
          <router-link :to="item.link">{{ item.hotword }}</router-link>
          <!-- <a :href="item.link">{{ item.hotword }}</a> -->
        </li>
      </ul>
    </div>
    <div class="infoBoxArea">
      <v-info-box
        v-bind:cTitle="infoBoxTitle_1"
        v-bind:cWords="infoBoxWords_1"
        style="margin-right=35px"
      ></v-info-box>
      <div class="blank"></div>
      <v-info-box
        v-bind:cTitle="infoBoxTitle_2"
        v-bind:cWords="infoBoxWords_2"
      ></v-info-box>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
import vInfoBox from "../components/InfoBox";
import vFooter from "../components/footer";

export default {
  name: "App",
  components: {
    vInfoBox,
    vFooter,
  },
  props: {},
  data() {
    return {
      search: "",
      hots: [
        { hotword: "热词:", link: "###" },
        { hotword: "身份证", link: "###" },
        { hotword: "脱贫", link: "###" },
        { hotword: "政务服务", link: "###" },
        { hotword: "学业", link: "###" },
        { hotword: "集约化平台资源分析", link: "###" },
        { hotword: "自治区门户搜索网站分析大屏", link: "###" },
        { hotword: "政策文件搜索", link: "policy_file" },
      ],
      infoBoxTitle_1: "热门服务",
      infoBoxWords_1: [
        { word: "证件办理", link: "###" },
        { word: "户籍办理", link: "###" },
        { word: "行政缴费", link: "###" },
        { word: "准营办理", link: "###" },
        { word: "设立变更", link: "###" },
        { word: "教育科研", link: "###" },
      ],
      infoBoxTitle_2: "搜索热点",
      infoBoxWords_2: [
        { word: "内蒙古", link: "###" },
        { word: "身份证", link: "###" },
        { word: "脱贫", link: "###" },
        { word: "政务服务", link: "###" },
        { word: "学业", link: "###" },
        { word: "政策", link: "###" },
      ],
    };
  },
  watch: {},
  computed: { 
    // 从vuex中获取search的值
    StoreSearch() {
      return this.$store.state.search;
    },
  },
  methods: {
    // 动态监听input输入框中的内容并传给store
    changeKey() {
      // console.log(this.search);
      // this.$store.commit("getSearchWord", this.search);
    },
    btn_seach() {
      // 进入门户;
      // let routeData = this.$router.resolve({
      //   name: "door",
      //   query: {
      //     keywords: this.search,
      //   },
      // });
      // window.open(routeData.href, "_blank");
      //
      // 进入公开;
      // let routeData = this.$router.resolve({
      //   name: "open",
      //   query: {
      //     keywords: this.search,
      //   },
      // });
      // window.open(routeData.href, "_blank");
      //
      // 进入政策;
      let routeData = this.$router.resolve({
        name: "policy",
        query: {
          keywords: this.search,
          content: "企业",
          docno: "内政发〔2000〕7号",
          year: "2000",
          month: "01",
        },
      });
      window.open(routeData.href, "_blank");
      // if (this.search === "" || this.search === " ") {
      //   this.$confirm("搜索内容不能为空", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   }); //用catch来捕获错误消息
      // } else {
      //   this.$router.push("door");
      // }
    },
  },
  created() {
    // 将从vuex中获取到的search的值赋值给本页面的search
    this.search = this.StoreSearch;
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
@import url(../assets/css/global.css);

.warper {
  height: 100%;
  padding-top: 40px;
}

.header {
  position: absolute;
  height: 14px;
  width: 140px;
  top: 10%;
  left: 80%;
}

.header a {
  color: rgb(16, 115, 183);
}

.header a:nth-child(1) {
  margin-right: 25px;
}
.logo {
  width: 470px;
  height: 310px;
  margin: 0 auto 0 auto;
  // margin-top: 70px;
  img {
    width: 100%;
    height: 100%;
  }
}

.searchBar {
  width: 700px;
  height: 50px;
  margin: 35px auto 0 auto;
  input {
    box-sizing: border-box;
    /* display: inline-block; */
    font-size: 20px;
    float: left;
  }

  input[type="text"] {
    width: 570px;
    height: 50px;
    border: 1px solid rgb(16, 115, 183);
    outline: none;
    border-radius: 5px 0 0 5px;
    padding-left: 20px;
  }

  input[type="button"] {
    width: 130px;
    height: 50px;
    margin-left: -5px;
    border-radius: 5px;
    border: none;
    outline: none;
    cursor: pointer;
    /* background-color: rgb(16, 115, 183); */
    color: #ffffff;
    background-image: url(../assets/img/search_btn_bg.png);
    background-size: 100% 100% no-repeat;
  }
}

.el-input {
  width: 700px;
  margin: 50px auto 0 auto;
}

.hot {
  width: 800px;
  height: 15px;
  margin: 10px auto 0 auto;
}

.hot ul li {
  float: left;
  font-size: 14px;
  margin-right: 4px;
}
.hot ul li a {
  color: rgb(16, 115, 183);
}
.hot ul li:nth-child(0) {
  margin-right: 5px;
}
.hot ul li:nth-child(5) {
  margin-right: 100px;
}
.infoBoxArea {
  width: 700px;
  height: 140px;
  margin: 10px auto 0 auto;
}
.blank {
  width: 35px;
  height: 140px;
  float: left;
}
</style>
